import React, { useContext, useEffect } from 'react';

import { nanoid } from '@reduxjs/toolkit';

import { MediaLibraryChooser } from '../../../../components/mediaLibrary';
import { MediaLibrary } from '../../../../types/mediaLibrary';
import { MediaFile } from '../../../../types/media';

import styles from './banner.module.scss'; 
import { DealRoomContext } from '../context';
import { DealRoomEditState } from 'src/types/dealRoom';

interface BannerEditorProps {
  dealRoom: DealRoomEditState;
}

const BannerEditor: React.FC<BannerEditorProps> = ({ dealRoom }) => {
  const dealRoomContext = useContext(DealRoomContext);
 
 
  const handleFileChange = (background: MediaFile) => {
    let banner = dealRoom.banner;
    if(!banner) {
      banner = {
        position: 'top',
        autoHeightEnabled: true,
        sharedByEnabled: true,
      };
    }

    dealRoomContext.updateDealRoomProperty('banner', {
      ...banner,
      background: background,
      crop: null,
    });

 
  }

  const handleBannerSelection = (media: MediaLibrary) => {
    if (!media) {
      return;
    }

    const imageUrl = media.imageUrl;
    if(!imageUrl) {
      return;
    }

    fetch(imageUrl)
    .then((response) => {
      return response.blob();
    })
    .then(blob => {
      const url = URL.createObjectURL(blob);

      const backgroundMedia = {
        id: nanoid(6),
        entityType: 'media-preview',
        type: media.mediaType,
        full: url,
        thumbnail: url,
        width: media.width,
        height: media.height,
        contentType: blob.type,
      } as MediaFile
    
      handleFileChange(backgroundMedia);
    }).catch(error => {
      console.error(error);
    });
  }

  return (
    <div className={styles.bannerChooser}>
      <MediaLibraryChooser entityType="collection" onChange={handleBannerSelection} columns={5}/>
    </div>
  );
}

export { BannerEditor };